export enum LoginStatus {
  Error = "Error",
  Success = "Success",
  CompanySelectionRequired = "CompanySelectionRequired",
  TwoFactorAuthenticationRequired = "TwoFactorAuthenticationRequired",
  ProperScopeSelectionRequired = "ProperScopeSelectionRequired",
  TwoFactorAuthenticationSetupRequired = "TwoFactorAuthenticationSetupRequired",
  UsernameValidationComplete = "UsernameValidationComplete",
}
